import { ENVIRONMENTS } from '@harvestiq/constants';
import { getBool, getNumber } from './utils';

// ENVIRONMENT
// if 'default' shows up, something's wrong
export function getEnv(): string {
  return process.env['ENVIRONMENT'] ?? 'default';
}

export function getVersion(): string {
  return process.env['VERSION'] ?? '0.0.default';
}

export function isDevelopment(): boolean {
  return (
    getEnv().toLowerCase() === ENVIRONMENTS.DEVELOPMENT ||
    getEnv().toLowerCase() === 'local'
  );
}

export function isTest(): boolean {
  return getEnv().toLowerCase() === ENVIRONMENTS.TEST;
}

export function isStaging(): boolean {
  return getEnv().toLowerCase() === ENVIRONMENTS.STAGING;
}

export function isProduction(): boolean {
  return getEnv().toLowerCase() === ENVIRONMENTS.PRODUCTION;
}

export function isCI(): boolean {
  return !!process.env['CI'];
}

export function isProductionNodeEnv(): boolean {
  return process.env['NODE_ENV']?.toLowerCase() === ENVIRONMENTS.PRODUCTION;
}

export function isDevelopmentNodeEnv(): boolean {
  return (
    process.env['NODE_ENV']?.toLowerCase() !== ENVIRONMENTS.PRODUCTION &&
    process.env['NODE_ENV']?.toLowerCase() !== ENVIRONMENTS.TEST
  );
}

export function isTestNodeEnv(): boolean {
  return process.env['NODE_ENV']?.toLowerCase() === ENVIRONMENTS.TEST;
}

export function isTestRunner(): boolean {
  return !!process.env['JEST_WORKER_ID'] || !!process.env['VITEST_POOL_ID'];
}

// checking if the code is running in a Lambda environment or locally
export function isLambdaRuntime(): boolean {
  return !!(
    process.env['AWS_LAMBDA_FUNCTION_NAME'] && process.env['LAMBDA_TASK_ROOT']
  );
}

export type LambdaWorkerType = 'reviq' | 'usda' | 'insureiq';
export function getLambdaWorkerType(): LambdaWorkerType {
  if (process.env['LAMBDA_WORKER_TYPE']) {
    return process.env['LAMBDA_WORKER_TYPE'].toLowerCase() as LambdaWorkerType;
  }

  // see if the AWS_LAMBDA_FUNCTION_NAME contains a known worker type
  if (process.env['AWS_LAMBDA_FUNCTION_NAME'] || process.env['DD_SERVICE']) {
    const functionName =
      process.env['AWS_LAMBDA_FUNCTION_NAME']?.toLowerCase() ||
      process.env['DD_SERVICE']?.toLowerCase() ||
      '';

    if (functionName.includes('reviq')) {
      return 'reviq';
    } else if (functionName.includes('usda')) {
      return 'usda';
    } else if (
      functionName.includes('insureiq') ||
      functionName.includes('default')
    ) {
      return 'insureiq';
    }
  }

  // default is insureiq
  return 'insureiq';
}

export function fetchSecretsFromStore(): boolean {
  return getBool('FETCH_SECRETS_FROM_STORE', false);
}

export function getAppName(): string {
  return process.env['APP_NAME'] || 'HarvestIQ';
}

export function getLocalStackEnabled(): boolean {
  return getBool('LOCALSTACK_ENABLED', false);
}

export function getIntegrationFileDirectory(): string {
  return process.env['INTEGRATIONS_LOCAL_FILE_DIRECTORY'] ?? '';
}

export function getFileDownloadConcurrency(): number {
  return getNumber('FILE_DOWNLOAD_CONCURRENCY', 1);
}

// TODO - remove this flag
export function areMinisEnabled(): boolean {
  return getBool('MINIS_ENABLED', true);
}
